
import './displayMessage.css'
function AuthGuard({children}) {
    const login = true;
  return (
    login ? children : null

  );

}

export default AuthGuard;
